module.exports = __webpack_public_path__ + "static/media/elementLogo.c6f43fb9.png";